import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const IconChart = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6668 12V10.6667H12.4002L8.9335 7.23333L6.26683 9.9L1.3335 4.93333L2.26683 4L6.26683 8L8.9335 5.33333L13.3335 9.73333V8H14.6668V12H10.6668Z"
      />
    </SvgIcon>
  );
};

export default IconChart;
